import { profileHex, profileInitials } from '@tv-casino/shared';
import type { SessionUser } from '@tv-casino/shared';

/**
 * The join page's line about who is sitting down. A signed-in account is
 * named, in its colour, with the badge the table will show beside it; a
 * guest is told what signing in would add, and nothing is withheld from them.
 */
export type JoinProfileVM =
  | {
      signedIn: true;
      /** The name the account plays under, else the account's own name. */
      name: string;
      email: string;
      initials: string;
      accentHex: string;
      /** Where the colour and badge go, in one sentence. */
      hint: string;
    }
  | {
      signedIn: false;
      hint: string;
    };

export function joinProfileModel(session: SessionUser | null, casinoName: string | null): JoinProfileVM {
  if (!session) {
    return {
      signedIn: false,
      hint: 'Playing as a guest. Sign in to wear your profile colour and badge at the table.',
    };
  }
  const name = session.playerName || session.name;
  return {
    signedIn: true,
    name,
    email: session.email,
    initials: profileInitials(name),
    accentHex: profileHex(session.profileColor),
    hint: session.profileColor
      ? `Your colour and profile badge follow you onto ${casinoName ?? 'the table'}.`
      : `Your profile badge follows you onto ${casinoName ?? 'the table'} — pick a colour on your profile.`,
  };
}
